import { render, staticRenderFns } from "./InFederalRegister.vue?vue&type=template&id=6f60bf86"
import script from "./InFederalRegister.vue?vue&type=script&lang=js"
export * from "./InFederalRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports